import * as actionTypes from './actionTypes';

const initialState = {
    payments: [],
    count: 0,
    truncated: false,
    // Distinguishes "no search yet" from "searched and found nothing", so the
    // screen can show guidance rather than an empty-result message on load.
    searched: false,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.UPDATE_PAYMENT_RESULTS:
            state = {
                ...state,
                payments: action.payload.payments || [],
                count: action.payload.count || 0,
                truncated: Boolean(action.payload.truncated),
                searched: true,
            }
            break;
        case actionTypes.CLEAR_PAYMENT_RESULTS:
            state = { ...initialState }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default reducer;
